import { fetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  IIndirectTaxTaxTypeDetailsParams,
  IIndirectTaxTaxTypeDetailsResponse,
} from './types';

export function useIndirectTaxRegistrationTaxTypeDetails(
  params: IIndirectTaxTaxTypeDetailsParams | null
) {
  const cacheKey = params
    ? `new-sales-tax/registrations-v2/content/tax-type-details:${params.corporationId}:${params.jurisdictionIds.sort().join(',')}`
    : null;

  const { data, mutate, error, isLoading } =
    useSWR<IIndirectTaxTaxTypeDetailsResponse>(cacheKey, async () => {
      if (!params) {
        throw new Error('Params required');
      }
      const response = await fetcher(
        'new-sales-tax/registrations-v2/content/tax-type-details',
        { method: 'POST', body: params },
        undefined
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || 'Failed to fetch tax type details'
        );
      }
      return response.json();
    });

  return {
    data,
    mutate,
    error,
    isLoading,
  };
}
